import { Modal } from "antd";
import React from "react";

interface AllowCameraConfirmationProps {
  isOpen: boolean;
  containerRef: React.RefObject<HTMLDivElement>;
  handleOk: () => void;
  handleCancelExit: () => void;
}

const AllowCameraConfirmation: React.FC<AllowCameraConfirmationProps> = ({
  isOpen,
  containerRef,
  handleCancelExit,
  handleOk,
}) => {
  return (
    <Modal
      title="Allow Camera Access ?"
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancelExit}
      okText={"Allow"}
      cancelText="Cancel"
      okButtonProps={{ type: "primary" }}
      centered
      maskClosable={false}
      closeIcon={false}
      getContainer={() => containerRef?.current!}
    >
      <p>
        By proceeding, you are granting access to your camera. Your webcam will
        be activated, and your face will be recorded during the interview for
        monitoring and evaluation purposes.
      </p>
      <p>
        By clicking "Allow", you acknowledge and accept the above-mentioned
        conditions.
      </p>
    </Modal>
  );
};

export default AllowCameraConfirmation;
